"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContainerWidth = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styledSystem = require("styled-system");

var _Theme = require("../../Theme/Theme.variables");

var _Theme2 = require("../../Theme/Theme.spacing");

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      @media (min-width: ", ") {\n        width: ", ";\n      }\n      @media (min-width: ", ") {\n        width: ", ";\n      }\n      @media (min-width: ", ") {\n        width: ", ";\n      }\n      @media (min-width: ", ") {\n        width: ", ";\n      }\n      @media (min-width: ", ") {\n        width: ", ";\n      }\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  box-sizing: border-box;\n  ", " ", ";\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // main style entrypoint


var ContainerWidth = _styledComponents.default.div(_templateObject(), function (props) {
  return (0, _Theme2.spacing)(props);
}, function (props) {
  return "\n    box-sizing: border-box;\n    margin-right: auto;\n    margin-left: auto;\n    max-width: 100%;\n    width: 100%;\n    padding-left: ".concat((0, _Theme.variables)(props).gutters['mobile'], "px;\n    padding-right: ").concat((0, _Theme.variables)(props).gutters['mobile'], "px;\n    @media (min-width: ").concat((0, _Theme.variables)(props).breakpoints['sm'], ") {\n      padding-left: ").concat((0, _Theme.variables)(props).gutters['desktop'], "px;\n      padding-right: ").concat((0, _Theme.variables)(props).gutters['desktop'], "px;\n    }\n  ");
}, function (props) {
  return !props.fluid && (0, _styledComponents.css)(_templateObject2(), (0, _Theme.variables)(props).breakpoints['xs'], (0, _Theme.variables)(props).widths['xs'], (0, _Theme.variables)(props).breakpoints['sm'], (0, _Theme.variables)(props).widths['sm'], (0, _Theme.variables)(props).breakpoints['md'], (0, _Theme.variables)(props).widths['md'], (0, _Theme.variables)(props).breakpoints['lg'], (0, _Theme.variables)(props).widths['lg'], (0, _Theme.variables)(props).breakpoints['xl'], (0, _Theme.variables)(props).widths['xl']);
}, _styledSystem.space);

exports.ContainerWidth = ContainerWidth;